<template>
    <Tabs type="card" @on-click="clickTab">
        <TabPane name="AdvAllTpyeStatic"  label="所有类型分析">
			<AdvAllTpyeStatic :clickTabValue="clickTabValue" ref="AdvAllTpyeStatic"></AdvAllTpyeStatic>
		</TabPane>
		<TabPane name="TypeStaticCity"  label="所有类型城市">
			<TypeStaticCity :clickTabValue="clickTabValue" ref="TypeStaticCity"></TypeStaticCity>
		</TabPane>
		<TabPane name="AccountStatic"  label="账户统计">
			<AccountStatic :clickTabValue="clickTabValue" ref="AccountStatic"></AccountStatic>
		</TabPane>
		<TabPane name="Lirun"  label="数据">
			<LirunVue :clickTabValue="clickTabValue" ref="LirunVue"></LirunVue>
		</TabPane>

    </Tabs>
</template>

<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import AdvAllTpyeStatic from "./AdvAllTpyeStatic.vue"
	import TypeStaticCity from "./TypeStaticCity.vue"
	import AccountStatic from "./AccountStatic.vue"
	import LirunVue from "./Lirun.vue";
	export default {
		name:"AdvStatic",
		components: {
			AdvAllTpyeStatic,
			AccountStatic,
			LirunVue,
			TypeStaticCity
		},
		computed: {
			...mapGetters([
				'userInfo', 'token'
			]),
		},
		data() {
			return {
				clickTabValue: "222",
			}
		},
		methods: {
			...mapActions([
				'getUserInfo',
			]),
			clickTab(e){
				if(e = "AccountStatic"){
					this.$refs['AccountStatic'].getList();
				}
				
			}
		}
	}
</script>

<style>
</style>
